const isChromeExtension = true // TODO: won't be true forever...
const noop = () => {}

export const sendMessage = (...args) => {
  if (chrome && chrome.runtime && isChromeExtension) {
    return chrome.runtime.sendMessage(...args)
  } else {
    return noop
  }
}
